// extracted by mini-css-extract-plugin
export default {"table-templete-outer":"index_table-templete-outer__JXAXc"};